import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import {
  DEFAULT_GRAPH_PALETTE_KEY,
  GraphPaletteKey,
} from '../constants/ColorsForGraph';

const { persistAtom: graphPalettePersistAtom } = recoilPersist({
  key: 'graphPalette',
});

export const graphPaletteKey = atom<GraphPaletteKey>({
  key: 'selectedGraphPalette',
  default: DEFAULT_GRAPH_PALETTE_KEY,
  effects_UNSTABLE: [graphPalettePersistAtom],
});
